export default __webpack_public_path__ + "static/media/person.300ba2b4.png";